module.exports = {
    JSON_CLEAN: {},
    ARRAY_CLEAN: [],
    RESULT_SUCCESS:'1',
    RESULT_FAILED:'2',
    RESULT_EXCEPTION: '3',

    //业务类型
    BUSI_TYPE:{
        REGISTRATION_PAYMENT:'1',//挂号缴费
        OUT_PATIENT_PAYMENT:'2', //门诊缴费
        IN_PATIENT_PAYMENT:'5', //住院充值
    },

    //订单类型
    ORDER_TYPE:{
        REGISTRATION_TYPE:1,         //挂号
        OUT_PATIENT_TYPE:2           //门诊处方
    },

    //挂号订单状态
    ORDER_STATUS:{
        UNABLE_PAYMENT: '1',       //未支付(不可支付)
        ABLE_PAYMENT:'2',         //未支付(可支付)
        UNABLE_RETURN_FEE:'3',    //已支付(不可退费)
        ABLE_RETURN_FEE:'4',      //已支付(可退费)
        RETIRED_NUMBER:'5',       //已退费(已退号)
        NO_REFUND:'6'             //已退号(未退费)
    },

    //挂号状态
    REGISTERED_STATUS:{
        UNINFORMED_STOP_CLINICAL:1,  //停诊未通知
        INFORMED_STOP_CLINICAL:2,    //停诊已通知
        INVALID:3,                   //失约作废
        RESERVATION:4,               //已预约
    },

    //医院ID
    HOSPITAL_ID:{
        RMYY: '1003', //人民医院
        FYBJ:'1005',  //妇幼保健
        ZXJH:'1007',  //中西结合
        JKSC:'3001',  //健康四川
        CDFY:'1056', //成大附医
        CDFN:'1055'  //成都妇女儿童
    },

    //调用方式
    INVOKE_TYPE:{
        APP_INVOKE:'1',     //app
        WAP_INVOKE:'2',     //wap
        QR_INVOKE:'3',      //扫码
        MEDICAL_INVOKE:'4',  //医保
        H5_INVOKE:'5',      //H5
    },

    //医院跳转方式
    JUMP_TYPE:{
        IN_LINK:'1',   //内部链接
        OUT_LINK:'2'   //外部链接
    },
    // 彭州全民信息平台数据上报服务类型
    SERVICE_ID: {
        HEALTH_RECORDS_QUERY: 'C01', // 健康档案调阅查询
        SELF_HEALTH_ASSESSMENT: 'C04', // 自我健康状况评估
        HEALTH_LIFE_GUIDANCE: 'C05', // 健康生活指导
        HEALTH_BASIC_INFORMATION: 'C07', // 健康档案基本信息维护
        HEALTH_CONSULTATION: 'C08', // 健康问题咨询
        HEALTH_RECORD_APPLICATION_AUTHORIZATION: 'C10', // 健康档案应用授权
        FAMILY_DOCTOR_SIGNING: 'C14', // 家庭医生签约
        EMERGENCY_CALL_SERVICE: 'C20', // 急救呼叫服务
    }
}



// WEBPACK FOOTER //
// ./src/config/consts.js